import axios from "axios";
import { toast } from "sonner";

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
const STORAGE_KEY = "prodtrack_session";

export const session = {
  load() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || null; } catch { return null; }
  },
  save(data) { localStorage.setItem(STORAGE_KEY, JSON.stringify(data)); },
  clear() { localStorage.removeItem(STORAGE_KEY); },
};

let onUnauthorized = () => {};
export const setUnauthorizedHandler = (fn) => { onUnauthorized = fn; };

export const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const s = session.load();
  if (s?.token) config.headers.Authorization = `Bearer ${s.token}`;
  const crossTenant = config.url.startsWith("/plans") || (config.url.startsWith("/entreprises") && !config.url.startsWith("/entreprises/moi"));
  if (s?.user?.role === "superadmin" && s?.entrepriseId && !crossTenant) {
    config.params = { ...(config.params || {}), entreprise_id: s.entrepriseId };
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error.response?.status;
    const detail = error.response?.data?.detail;
    if (status === 401) {
      onUnauthorized();
      toast.error("Session expirée — reconnectez-vous");
    } else if (status === 403) {
      toast.error(typeof detail === "string" ? detail : "Droits insuffisants");
    }
    error.message = typeof detail === "string" ? detail : `Erreur ${status || "réseau"}`;
    return Promise.reject(error);
  }
);

export const get = (url, params) => api.get(url, { params }).then((r) => r.data);
export const post = (url, body) => api.post(url, body).then((r) => r.data);
export const put = (url, body) => api.put(url, body).then((r) => r.data);
export const del = (url) => api.delete(url).then((r) => r.data);
